import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskItsmFeaturesRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-itsm-features',
	path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
	exact: true,
};
